import { PortfolioShortDataByPeriod } from 'model/modules/portfolio/portfolio';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import { mapOperationItemFromApi } from 'rtkQuery/sharespro/mapper/modules/operations/mapOperationsFromApi';
import mapPortfolioChartDataFromApi from './mapPortfolioChartDataFromApi';
import { mapPortfolioBalanceInfo } from './mapPortfolioDataFromApi';

const mapPortfolioShortDataFromApi = (
  resp: SharesproApiResponse<ApiFetchPortfolioShortDataByPeriod>
): PortfolioShortDataByPeriod => {
  return {
    chart: mapPortfolioChartDataFromApi(resp.data.chart),
    balanceInfo: mapPortfolioBalanceInfo(resp.data.balance),
    operations: resp.data.operations.map(mapOperationItemFromApi),
  };
};

export default mapPortfolioShortDataFromApi;
